// import React, { useEffect, useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import "./TicketDetails.css";

// /** ---- endpoints ---- */
// const TXN_SEARCH_URL = "https://www.lianfoong.com/api/pawn-transactions/search"; // GET ?mmyy=&receiptNo=
// const TXN_BY_RECEIPT_FALLBACKS = [
//   "https://www.lianfoong.com/api/pawn-transactions/by-receipt",
//   "https://www.lianfoong.com/api/pawn-transactions/getByReceiptNo",
// ];
// const CUSTOMER_BY_NRIC = "https://www.lianfoong.com/api/customers/by-nric"; // GET ?nirc=
// const PRINT_URL = "https://www.lianfoong.com/api/pawn-transactions/print";   // GET ?receiptNo=&alsoPrint=

// /** ---- tiny helpers ---- */
// const fmtMoney = (v) =>
//   v === null || v === undefined || v === ""
//     ? "-"
//     : Number(v).toLocaleString("en-SG", {
//         style: "currency",
//         currency: "SGD",
//         minimumFractionDigits: 2,
//       });

// const fmtDate = (s) => {
//   if (!s) return "-";
//   const d = new Date(s);
//   if (Number.isNaN(d.getTime())) return s;
//   const dd = String(d.getDate()).padStart(2, "0");
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const yyyy = d.getFullYear();
//   return `${dd}/${mm}/${yyyy}`;
// };

// const Row = ({ label, value, mono }) => (
//   <div className="td-row">
//     <div className="td-label">{label}</div>
//     <div className={`td-value ${mono ? "mono" : ""}`}>{value ?? "-"}</div>
//   </div>
// );

// export default function TicketDetails() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { receiptNo: receiptParam } = useParams();

//   // Accept data from previous page if provided
//   const presetTxn = location.state?.transaction || null;
//   const stateReceipt = location.state?.receiptNo || presetTxn?.receiptNo || null;
//   const stateMMYY = location.state?.mmyy || null;

//   const receiptNo = useMemo(
//     () => stateReceipt || receiptParam || "",
//     [stateReceipt, receiptParam]
//   );
//   const [mmyy, setMmyy] = useState(stateMMYY || "");

//   const [txn, setTxn] = useState(presetTxn);
//   const [pawner, setPawner] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [printing, setPrinting] = useState(false);
//   const [err, setErr] = useState("");

//   // Esc → back
//   useEffect(() => {
//     const onKey = (e) => e.key === "Escape" && navigate(-1);
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [navigate]);

//   // Fetch transaction, then pawner
//   useEffect(() => {
//     let cancelled = false;

//     const fetchTxn = async () => {
//       if (!receiptNo && !presetTxn) return;
//       setLoading(true);
//       setErr("");

//       try {
//         let tx = presetTxn;

//         // 1) if not pre-provided, try search API (needs mmyy)
//         if (!tx && receiptNo && mmyy) {
//           const { data } = await axios.get(TXN_SEARCH_URL, {
//             params: { mmyy, receiptNo },
//           });
//           tx = data || null;
//         }

//         // 2) fallback: try “by-receipt” style endpoints
//         if (!tx && receiptNo) {
//           for (const url of TXN_BY_RECEIPT_FALLBACKS) {
//             try {
//               const { data } = await axios.get(url, { params: { receiptNo } });
//               if (data) {
//                 tx = data;
//                 break;
//               }
//             } catch {
//               /* try next */
//             }
//           }
//         }

//         if (!tx) throw new Error("Ticket not found.");

//         if (cancelled) return;
//         setTxn(tx);

//         // 3) fetch pawner details
//         if (tx?.pawnerNirc) {
//           try {
//             const { data } = await axios.get(CUSTOMER_BY_NRIC, {
//               params: { nirc: tx.pawnerNirc },
//             });
//             if (!cancelled) setPawner(data || null);
//           } catch {
//             if (!cancelled) setPawner(null);
//           }
//         } else {
//           setPawner(null);
//         }
//       } catch (e) {
//         console.error(e);
//         if (!cancelled) setErr(e?.message || "Failed to load ticket.");
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     };

//     fetchTxn();
//     return () => {
//       cancelled = true;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [receiptNo, mmyy]);

//   /** Use /print API. If alsoPrint=true, backend will try to print and still return a PDF. */
//   const handlePrintApi = async (alsoPrint = false) => {
//     if (!txn?.receiptNo) return;
//     setPrinting(true);
//     try {
//       const res = await axios.get(PRINT_URL, {
//         params: { receiptNo: txn.receiptNo, alsoPrint },
//         responseType: "blob",
//       });

//       // Save the returned PDF
//       const blob = new Blob([res.data], { type: "application/pdf" });
//       const cd =
//         res.headers["content-disposition"] ||
//         res.headers["Content-Disposition"] ||
//         "";
//       const m = cd.match(/filename="?([^"]+)"?/i);
//       const filename = m?.[1] || `receipt_${txn.receiptNo}.pdf`;

//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       URL.revokeObjectURL(url);
//     } catch (e) {
//       console.error(e);
//       alert("Print service unavailable. Please try again.");
//     } finally {
//       setPrinting(false);
//     }
//   };

//   return (
//     <div className="ticket-details-container">
//       <div className="td-header">
//         <div>
//           <h2>Ticket Details</h2>
//           {receiptNo && (
//             <div className="td-sub">
//               Receipt No: <span className="mono">{receiptNo}</span>
//               <span className="td-esc-hint"> (Press Esc to go back)</span>
//             </div>
//           )}
//         </div>
//         <div className="td-actions">
//           <button className="ghost" type="button" onClick={() => navigate(-1)}>
//             Back
//           </button>
//           <button
//             className="primary"
//             type="button"
//             disabled={!txn?.receiptNo || printing}
//             onClick={() => handlePrintApi(false)}
//             title="Download PDF via /print"
//           >
//             {printing ? "Working…" : "Download PDF"}
//           </button>
//           <button
//             className="primary"
//             type="button"
//             disabled={!txn?.receiptNo || printing}
//             onClick={() => handlePrintApi(true)}
//             title="Trigger server print and download PDF"
//           >
//             {printing ? "Printing…" : "Print"}
//           </button>
//         </div>
//       </div>

//       {loading && (
//         <div className="td-card">
//           <div className="td-loading">Loading…</div>
//         </div>
//       )}
//       {err && !loading && (
//         <div className="td-card td-error">
//           <div>{err}</div>
//         </div>
//       )}

//       {!loading && txn && (
//         <>
//           <div className="td-card">
//             <div className="td-section-title">Transaction</div>
//             <div className="td-grid">
//               <Row label="Receipt No" value={txn.receiptNo} mono />
//               <Row label="Items" value={txn.item || txn.items} />
//               <Row label="No. of Items" value={txn.noOfItem} />
//               <Row label="Weight" value={txn.weight} mono />
//               <Row
//                 label="Principal"
//                 value={fmtMoney(txn.amount ?? txn.principal)}
//               />
//               <Row
//                 label="Valuation"
//                 value={fmtMoney(txn.valuationAmount ?? txn.valuation)}
//               />
//               <Row label="Remark" value={txn.remark} />
//               <Row label="Grant Date" value={fmtDate(txn.grantDate)} />
//               <Row label="Expiry Date" value={fmtDate(txn.expiryDate)} />
//               <Row label="Handler" value={txn.handler} mono />
//               <Row
//                 label="Active"
//                 value={String(txn.activeRecord ?? txn.active ?? "").toUpperCase()}
//                 mono
//               />
//             </div>
//           </div>

//           <div className="td-card">
//             <div className="td-section-title">Pawner</div>
//             {pawner ? (
//               <div className="td-grid">
//                 <Row label="NRIC" value={pawner.nirc} mono />
//                 <Row label="Name" value={pawner.name} />
//                 <Row label="Race" value={pawner.race} />
//                 <Row label="Sex" value={pawner.sex} />
//                 <Row label="Nationality" value={pawner.nationality} />
//                 <Row label="DOB" value={fmtDate(pawner.dob)} />
//                 <Row label="Mobile" value={pawner.contactNoMobile} mono />
//                 <Row
//                   label="Blacklisted"
//                   value={String(pawner.blacklisted ?? false).toUpperCase()}
//                   mono
//                 />
//                 <Row label="Address (SG)" value={pawner.sgAddr} />
//                 {pawner.foreignAddr && (
//                   <Row label="Address (Foreign)" value={pawner.foreignAddr} />
//                 )}
//               </div>
//             ) : (
//               <div className="td-hint">
//                 Pawner profile not found for{" "}
//                 <span className="mono">{txn.pawnerNirc || "-"}</span>.
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }
// src/components/TicketDetails.jsx
// src/components/TicketDetails.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./TicketDetails.css";

/** ---- endpoints ---- */
const TXN_SEARCH_URL = "https://www.lianfoong.com/api/pawn-transactions/search"; // GET ?mmyy=&receiptNo=
const TXN_BY_RECEIPT_FALLBACKS = [
  "https://www.lianfoong.com/api/pawn-transactions/by-receipt",
  "https://www.lianfoong.com/api/pawn-transactions/getByReceiptNo",
];
const CUSTOMER_BY_NRIC = "https://www.lianfoong.com/api/customers/by-nric"; // GET ?nirc=
const PRINT_URL = "https://www.lianfoong.com/api/pawn-transactions/print"; // GET ?receiptNo=&alsoPrint=

/** ---- tiny helpers ---- */
const fmtMoney = (v) =>
  v === null || v === undefined || v === ""
    ? "-"
    : Number(v).toLocaleString("en-SG", {
        style: "currency",
        currency: "SGD",
        minimumFractionDigits: 2,
      });

const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(s);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const normNric = (s) =>
  String(s || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "")
    .replace(/[^A-Z0-9]/g, "");

/**
 * ✅ Compare NRICs even if old system stored without the first letter.
 * Examples:
 *  - S7540741F -> key: 7540741F
 *  - 7540741F  -> key: 7540741F
 */
const nricKey = (s) => {
  const v = normNric(s);

  // Full NRIC: S1234567A / T... / F... / G... / M...
  const mFull = v.match(/^[STFGM](\d{7}[A-Z])$/);
  if (mFull) return mFull[1];

  // Old format: 1234567A
  const mOld = v.match(/^(\d{7}[A-Z])$/);
  if (mOld) return mOld[1];

  return v; // fallback
};

const pick = (obj, ...keys) => {
  for (const k of keys) {
    const v = obj?.[k];
    if (v !== undefined && v !== null) return v;
  }
  return undefined;
};

const Row = ({ label, value, mono }) => (
  <div className="td-row">
    <div className="td-label">{label}</div>
    <div className={`td-value ${mono ? "mono" : ""}`}>{value ?? "-"}</div>
  </div>
);

export default function TicketDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { receiptNo: receiptParam } = useParams();

  // Accept data from previous page if provided
  const presetTxn = location.state?.transaction || null;
  const stateReceipt = location.state?.receiptNo || presetTxn?.receiptNo || null;
  const stateMMYY = location.state?.mmyy || null;

  const receiptNo = useMemo(
    () => stateReceipt || receiptParam || "",
    [stateReceipt, receiptParam]
  );
  const [mmyy] = useState(stateMMYY || "");

  const [txn, setTxn] = useState(presetTxn);
  const [pawner, setPawner] = useState(null);

  // Redeemer profile (only shown when third party)
  const [redeemer, setRedeemer] = useState(null);

  const [loading, setLoading] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [err, setErr] = useState("");

  // Esc → back
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && navigate(-1);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  // Derived fields (support slightly different backend keys)
  const pawnerNricRaw = useMemo(
    () => pick(txn, "pawnerNirc", "pawner_nirc"),
    [txn]
  );
  const redeemByRaw = useMemo(
    () => pick(txn, "redeemBy", "redeem_by"),
    [txn]
  );

  const pawnerKeyNric = useMemo(() => nricKey(pawnerNricRaw), [pawnerNricRaw]);
  const redeemByKeyNric = useMemo(() => nricKey(redeemByRaw), [redeemByRaw]);

  const isRedeemed = useMemo(() => {
    const redeemDate = pick(txn, "redeemDate", "redeem_date");
    const redeemAmt = pick(txn, "redeemAmount", "redeem_amount");
    return Boolean(redeemDate || redeemAmt || redeemByRaw);
  }, [txn, redeemByRaw]);

  const isThirdPartyRedeem = useMemo(() => {
    if (!isRedeemed) return false;
    if (!pawnerKeyNric || !redeemByKeyNric) return false;
    return pawnerKeyNric !== redeemByKeyNric;
  }, [isRedeemed, pawnerKeyNric, redeemByKeyNric]);

  // Show Redeem By nicely:
  // If redeemBy is old-format but matches the pawner, display the full pawner NRIC.
  const redeemByDisplay = useMemo(() => {
    if (!redeemByRaw) return "-";
    if (pawnerNricRaw && nricKey(redeemByRaw) === nricKey(pawnerNricRaw)) {
      return normNric(pawnerNricRaw);
    }
    return normNric(redeemByRaw);
  }, [redeemByRaw, pawnerNricRaw]);

  // Fetch transaction, then pawner (+ redeemer if redeemed & third party)
  useEffect(() => {
    let cancelled = false;

    const fetchCustomer = async (nric) => {
      const v = normNric(nric);
      if (!v) return null;
      try {
        const { data } = await axios.get(CUSTOMER_BY_NRIC, { params: { nirc: v } });
        return data || null;
      } catch {
        return null;
      }
    };

    const fetchTxn = async () => {
      if (!receiptNo && !presetTxn) return;

      setLoading(true);
      setErr("");

      try {
        let tx = presetTxn;

        // 1) if not pre-provided, try search API (needs mmyy)
        if (!tx && receiptNo && mmyy) {
          const { data } = await axios.get(TXN_SEARCH_URL, {
            params: { mmyy, receiptNo },
          });
          tx = data || null;
        }

        // 2) fallback: try “by-receipt” style endpoints
        if (!tx && receiptNo) {
          for (const url of TXN_BY_RECEIPT_FALLBACKS) {
            try {
              const { data } = await axios.get(url, { params: { receiptNo } });
              if (data) {
                tx = data;
                break;
              }
            } catch {
              /* try next */
            }
          }
        }

        if (!tx) throw new Error("Ticket not found.");
        if (cancelled) return;

        setTxn(tx);

        const pawnerN = pick(tx, "pawnerNirc", "pawner_nirc");
        const redeemBy = pick(tx, "redeemBy", "redeem_by");

        // Load pawner first
        const pawnerData = pawnerN ? await fetchCustomer(pawnerN) : null;
        if (cancelled) return;
        setPawner(pawnerData);

        // Decide redeemer profile:
        // - If not redeemed: none
        // - If redeemBy matches pawner (even without prefix): reuse pawner profile
        // - Else (third party): try fetch redeemer profile (may be null)
        if (!redeemBy) {
          setRedeemer(null);
        } else {
          const samePerson = nricKey(redeemBy) && nricKey(pawnerN) && nricKey(redeemBy) === nricKey(pawnerN);

          if (samePerson) {
            setRedeemer(pawnerData); // ✅ fixes old data case like Sxxxx vs xxxx
          } else {
            const redeemerData = await fetchCustomer(redeemBy);
            if (!cancelled) setRedeemer(redeemerData);
          }
        }
      } catch (e) {
        console.error(e);
        if (!cancelled) setErr(e?.message || "Failed to load ticket.");
        if (!cancelled) {
          setTxn(null);
          setPawner(null);
          setRedeemer(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchTxn();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptNo, mmyy]);

  /** Use /print API. If alsoPrint=true, backend will try to print and still return a PDF. */
  const handlePrintApi = async (alsoPrint = false) => {
    if (!txn?.receiptNo) return;
    setPrinting(true);
    try {
      const res = await axios.get(PRINT_URL, {
        params: { receiptNo: txn.receiptNo, alsoPrint },
        responseType: "blob",
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      const cd =
        res.headers["content-disposition"] ||
        res.headers["Content-Disposition"] ||
        "";
      const m = cd.match(/filename="?([^"]+)"?/i);
      const filename = m?.[1] || `receipt_${txn.receiptNo}.pdf`;

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      alert("Print service unavailable. Please try again.");
    } finally {
      setPrinting(false);
    }
  };

  const oldReceiptNo = useMemo(() => {
    const v = pick(txn, "oldReceiptNo", "old_receipt_no");
    return v && String(v).trim() ? String(v).trim() : "-";
  }, [txn]);

  const redeemDate = pick(txn, "redeemDate", "redeem_date");
  const redeemAmount = pick(txn, "redeemAmount", "redeem_amount");
  const redeemHandler = pick(txn, "redeemHandler", "redeem_handler");

  return (
    <div className="ticket-details-container">
      <div className="td-header">
        <div>
          <h2>Ticket Details</h2>
          {receiptNo && (
            <div className="td-sub">
              Receipt No: <span className="mono">{receiptNo}</span>
              <span className="td-esc-hint"> (Press Esc to go back)</span>
            </div>
          )}
        </div>
        <div className="td-actions">
          <button className="ghost" type="button" onClick={() => navigate(-1)}>
            Back
          </button>
          <button
            className="primary"
            type="button"
            disabled={!txn?.receiptNo || printing}
            onClick={() => handlePrintApi(false)}
            title="Download PDF via /print"
          >
            {printing ? "Working…" : "Download PDF"}
          </button>
          <button
            className="primary"
            type="button"
            disabled={!txn?.receiptNo || printing}
            onClick={() => handlePrintApi(true)}
            title="Trigger server print and download PDF"
          >
            {printing ? "Printing…" : "Print"}
          </button>
        </div>
      </div>

      {loading && (
        <div className="td-card">
          <div className="td-loading">Loading…</div>
        </div>
      )}

      {err && !loading && (
        <div className="td-card td-error">
          <div>{err}</div>
        </div>
      )}

      {!loading && txn && (
        <>
          <div className="td-card">
            <div className="td-section-title">Transaction</div>
            <div className="td-grid">
              <Row label="Receipt No" value={txn.receiptNo} mono />
              <Row label="Old Receipt No" value={oldReceiptNo} mono />
              <Row label="Items" value={txn.item || txn.items} />
              <Row label="No. of Items" value={txn.noOfItem} />
              <Row label="Weight" value={txn.weight} mono />
              <Row label="Principal" value={fmtMoney(txn.amount ?? txn.principal)} />
              <Row label="Valuation" value={fmtMoney(txn.valuationAmount ?? txn.valuation)} />
              <Row label="Remark" value={txn.remark} />
              <Row label="Grant Date" value={fmtDate(txn.grantDate)} />
              <Row label="Expiry Date" value={fmtDate(txn.expiryDate)} />
              <Row label="Handler" value={txn.handler} mono />
              <Row
                label="Active"
                value={String(txn.activeRecord ?? txn.active ?? "").toUpperCase()}
                mono
              />
            </div>
          </div>

          {/* Redemption details */}
          {isRedeemed && (
            <div className="td-card">
              <div className="td-section-title">Redemption</div>
              <div className="td-grid">
                <Row label="Redeem Date" value={fmtDate(redeemDate)} />
                <Row label="Redeem Amount" value={fmtMoney(redeemAmount)} />
                <Row label="Redeem Handler" value={redeemHandler || "-"} mono />
                <Row label="Redeem By (NRIC)" value={redeemByDisplay} mono />
                <Row label="Redeem By (Name)" value={redeemer?.name || "-"} />
                <Row
                  label="Redeemed By"
                  value={isThirdPartyRedeem ? "THIRD PARTY" : "PAWNER"}
                  mono
                />
              </div>
            </div>
          )}

          <div className="td-card">
            <div className="td-section-title">Pawner</div>
            {pawner ? (
              <div className="td-grid">
                <Row label="NRIC" value={pawner.nirc} mono />
                <Row label="Name" value={pawner.name} />
                <Row label="Race" value={pawner.race} />
                <Row label="Sex" value={pawner.sex} />
                <Row label="Nationality" value={pawner.nationality} />
                <Row label="DOB" value={fmtDate(pawner.dob)} />
                <Row label="Mobile" value={pawner.contactNoMobile} mono />
                <Row
                  label="Blacklisted"
                  value={String(pawner.blacklisted ?? false).toUpperCase()}
                  mono
                />
                <Row label="Address (SG)" value={pawner.sgAddr} />
                {pawner.foreignAddr && (
                  <Row label="Address (Foreign)" value={pawner.foreignAddr} />
                )}
              </div>
            ) : (
              <div className="td-hint">
                Pawner profile not found for{" "}
                <span className="mono">{normNric(pawnerNricRaw) || "-"}</span>.
              </div>
            )}
          </div>

          {/* Redeemer profile only if THIRD PARTY */}
          {isRedeemed && isThirdPartyRedeem && (
            <div className="td-card">
              <div className="td-section-title">Redeemer (Third Party)</div>
              {redeemer ? (
                <div className="td-grid">
                  <Row label="NRIC" value={redeemer.nirc} mono />
                  <Row label="Name" value={redeemer.name} />
                  <Row label="Race" value={redeemer.race} />
                  <Row label="Sex" value={redeemer.sex} />
                  <Row label="Nationality" value={redeemer.nationality} />
                  <Row label="DOB" value={fmtDate(redeemer.dob)} />
                  <Row label="Mobile" value={redeemer.contactNoMobile} mono />
                  <Row
                    label="Blacklisted"
                    value={String(redeemer.blacklisted ?? false).toUpperCase()}
                    mono
                  />
                  <Row label="Address (SG)" value={redeemer.sgAddr} />
                  {redeemer.foreignAddr && (
                    <Row label="Address (Foreign)" value={redeemer.foreignAddr} />
                  )}
                </div>
              ) : (
                <div className="td-hint">
                  Redeemer profile not found for{" "}
                  <span className="mono">{redeemByDisplay}</span>.
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
